import WeatherLoations from './WeatherLocations'

export default WeatherLoations
